// extracted by mini-css-extract-plugin
export default {"mCard":"aE-z","image":"bE-z","imageNoBackground":"cE-z","imageHasCategory":"dE-z","fullWidth":"eE-z"};